import React from 'react';
import * as ReactDOM from "react-dom/client";
import {
    createBrowserRouter,
    Outlet,
    RouterProvider
} from "react-router-dom";
import App from './app';
import ProtectedRoute from './shared/protected-route';
import { AuthUser } from "./shared/user";
import { UserContextProvider } from './shared/user-context';
import NotAuthorised from './pages/not-authorised';
import Login from './components/auth/login';
import Logout from './components/auth/logout';
import { loader as logDetailsLoader } from "./components/log/log-details";
import { loader as logIgnoreDetailsLoader } from "./components/log/log-ignore-update";
import { action as addLogIgnoreAction } from "./components/log/log-ignore-add-or-update";
import Sample from './components/Sample';
import Layout from './pages/layout/layout';
import ErrorPage from './pages/error-page';
import { LogContextProvider } from './shared/log-context';
import ConfirmationModalContextProvider from './shared/useConfirm';
// const ErrorPage = React.lazy(() => import("./pages/error-page"));
const NotFoundPage = React.lazy(() => import("./pages/not-found-page"));
const LogListWithFilter = React.lazy(() => import('./components/log/log-list'));
const LogDetails = React.lazy(() => import('./components/log/log-details'));
const LogIgnoreListWithFilter = React.lazy(() => import('./components/log/log-ignore-keyword-list'));
const LogIgnoreFormAdd = React.lazy(() => import('./components/log/log-ignore-add'));
const LogIgnoreFormUpdate = React.lazy(() => import('./components/log/log-ignore-update'));


const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: ":module/log",
                element:                 
                 <ProtectedRoute onAuthorisation={function (user?: AuthUser | undefined): boolean {
                    return (user && user?.token) ? true : false
                }} >
                    <LogContextProvider>
                        <ConfirmationModalContextProvider> 
                            <Outlet />   
                        </ConfirmationModalContextProvider>                                        
                    </LogContextProvider>
                </ProtectedRoute>,
                children: [
                    {
                        index: true,
                        path: "list",
                        element: <LogListWithFilter />,
                    },
                    {
                        path: ":logId",
                        element: <LogDetails />,
                        loader: logDetailsLoader,
                    },
                    {
                        path: "ignore-keyword",
                        element: <Outlet />,
                        children: [
                            {
                                index: true,
                                path: "list",
                                element: <LogIgnoreListWithFilter />,
                            },
                            {
                                path: "add",
                                element: <LogIgnoreFormAdd />,
                                action: addLogIgnoreAction,
                            },
                            {
                                path: "update/:id",
                                element: <LogIgnoreFormUpdate />,
                                loader: logIgnoreDetailsLoader,
                                action: addLogIgnoreAction,
                            }
                        ]
                    }
                ]
            },
        ],
    },
    {
        path: '/new-request',
        element: (
            <Layout><Sample /></Layout>
        )
    },
    {
        path: '/login',
        element: (
            <Layout>
                <Login />
            </Layout>
        ),
    },
    {
        path: '/logout',
        element: (
            <Layout>
                <Logout auto={true} />
            </Layout>
        ),
    },
    {
        path: "/not-authorised",
        element: (
            <Layout>
                <NotAuthorised />
            </Layout>
        )
    },
    {
        path: "/error",
        element: (
            <Layout>
                <ErrorPage />
            </Layout>
        )
    },
    {
        path: "*",
        element: (
            <Layout>
                <NotFoundPage />
            </Layout>
        ),
    }
], {
    basename: "/",
    //basename: "/o2logs/"
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
    .render(
        <React.StrictMode>
            <UserContextProvider>
                <RouterProvider router={router} />
            </UserContextProvider>
        </React.StrictMode>
    );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
